
export class ElementOption {
    constructor(
        /**
         * Name of the option
         */
        public name: string,

        /**
         * Value of the option
         */
        public codename: string
    ) { }
}
